<template>
  <li :class="isActive ? 'active' : '' ">
    <a :href="item.path" @click="selectItem">
      <div class="pull-left">
        <i :class="classNames"></i>
        <p class="right-nav-wrapper mr-20">
          <span class="'right-nav-text'">{{$t(item.localeKey)}}</span>
        </p>
      </div>
      <div class="clearfix"></div>
    </a>
  </li>
</template>

<script>
import GenericButton from "@/components/shared/buttons/GenericButton";

export default {
  name: "NavigationSideBar",
  components: {
    "generic-button": GenericButton
  },
  props: {
    item: {
      type: Object,
      required: true
    },
    isActive: {
      type: Boolean,
      default: false
    },
  },
  data() {
    return {};
  },
  created() {
  },
  computed: {
    classNames() {
      return `${this.item.iconClass} mr-20 pull-left`;
    }
  },
  methods: {
    selectItem() {
      this.$emit('selectItem')
    }
  }
};
</script>

<style lang="scss" scoped>
.right-nav-wrapper {
  float: left;
  width: 100px;
}

.active {
  background: rgba(33, 33, 33, 0.05);
  color: #000000;
}
</style>



// WEBPACK FOOTER //
// src/components/shared/navigations/NavigationSideBarItem.vue